// anniversaryEndpoints.js
import { baseApi } from '../baseApi';

export const anniversaryApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({

    getAnniversaries: builder.query({
      query: (params = {}) => {
        // Dashboard mini-table passes a plain string ('NEXT_7', 'PAST_7', 'MONTH')
        if (typeof params === 'string') {
          return {
            url: '/dashboard/anniversaries',
            method: 'GET',
            params: { filterType: params },
          };
        }

        // Detail page / infinite-scroll passes a full object
        return {
          url: '/dashboard/anniversaries',
          method: 'GET',
          params: {
            ...params,
            pageNumber: params.pageNumber ?? 1,
            pageSize: params.pageSize ?? 30,
          },
        };
      },
    }),

  }),
});

export const {
  useGetAnniversariesQuery,
  useLazyGetAnniversariesQuery,   // ← used by TablesView for infinite scroll
} = anniversaryApi;